import EditRepeatedModal from './EditRepeatedModal'

export default EditRepeatedModal
